<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "Cheque",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
</style>

